module.exports = __webpack_public_path__ + "img/adn_konecta.5eb1d36f.png";